/**
 * Micsoreaza o poza in browser, inainte de urcare.
 *
 * Agentul din teren incarca de pe telefon, pe date mobile. O poza de telefon are 6-8 MB; zece
 * poze inseamna 70 de megaocteti si cateva minute de asteptare langa stand. Micsorata la 2000
 * de pixeli pe latura lunga, aceeasi poza are sub un megaoctet si se vede la fel pe ecran.
 *
 * Se pierde rezolutia originala. E o alegere, nu o scapare: pozele astea sunt dovada ca standul
 * a aratat cum trebuie, nu material de tipar. Ce merge la tipar sta oricum in arhiva de bannere.
 *
 * Miniatura se face din aceeasi imagine deja decodata — a doua decodare ar dubla munca pe un
 * telefon care si asa se chinuie.
 */

const LATURA_MARE = 2000
const LATURA_MINIATURA = 320
const CALITATE = 0.85
const CALITATE_MINIATURA = 0.7

export interface PozaPregatita {
  fisier: File
  miniatura: string
}

function deseneaza(img: HTMLImageElement, latura: number, calitate: number): string {
  const scara = Math.min(1, latura / Math.max(img.naturalWidth, img.naturalHeight))
  const c = document.createElement('canvas')
  c.width = Math.round(img.naturalWidth * scara)
  c.height = Math.round(img.naturalHeight * scara)
  const ctx = c.getContext('2d')
  if (!ctx) throw new Error('Browserul nu poate desena imaginea.')
  ctx.drawImage(img, 0, 0, c.width, c.height)
  return c.toDataURL('image/jpeg', calitate)
}

function dataUriInFile(dataUri: string, nume: string): File {
  const [antet, date] = dataUri.split(',')
  const tip = /:(.*?);/.exec(antet)?.[1] ?? 'image/jpeg'
  const binar = atob(date)
  const octeti = new Uint8Array(binar.length)
  for (let i = 0; i < binar.length; i++) octeti[i] = binar.charCodeAt(i)
  return new File([octeti], nume, { type: tip })
}

/** Numele isi schimba extensia: continutul e JPEG acum, oricare ar fi fost inainte. */
function numeJpeg(nume: string): string {
  return nume.replace(/\.[^.]+$/, '') + '.jpg'
}

export async function micsoreazaPoza(fisier: File): Promise<PozaPregatita> {
  const url = URL.createObjectURL(fisier)
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image()
      el.onload = () => resolve(el)
      el.onerror = () => reject(new Error('Fișierul nu pare a fi o imagine.'))
      el.src = url
    })
    return {
      fisier: dataUriInFile(deseneaza(img, LATURA_MARE, CALITATE), numeJpeg(fisier.name)),
      miniatura: deseneaza(img, LATURA_MINIATURA, CALITATE_MINIATURA),
    }
  } finally {
    URL.revokeObjectURL(url)
  }
}
